import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/contributions`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/contributions/${id}`, options)
        .then(response => {
            let contributions = jsona.deserialize(response.data);
            delete contributions.links;
            return contributions;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/contributions/${id}`, options)
        .then(response => {
            let contributions = jsona.deserialize(response.data);
            delete contributions.links;
            return contributions;
        });
}

function add (contributions) {
    const payload = jsona.serialize({
        stuff: contributions,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/contributions`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (contribution) {
    const payload = jsona.serialize({
        stuff: contribution,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/contributions/${contribution.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function activities (id) {
    let options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };
    return axios.get(`${url}/contributions/${id}/activity`, options)
        .then(response => {
            console.log(response.data);
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/contributions/${id}`, options);
}

export default {
    list,
    get,
    show,
    activities,
    add,
    update,
    destroy
};

